import { render, staticRenderFns } from "./Statistical_Order.vue?vue&type=template&id=41b48356&scoped=true&"
import script from "./Statistical_Order.vue?vue&type=script&lang=js&"
export * from "./Statistical_Order.vue?vue&type=script&lang=js&"
import style0 from "./Statistical_Order.vue?vue&type=style&index=0&id=41b48356&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "41b48356",
  null
  
)

export default component.exports